module.exports = __webpack_public_path__ + "static/media/ac6.aa0fcfdc.jpg";